<template>
  <div class="login-container">
    <div class="login-box">
      <div class="logo-section">
        <img src="@/assets/logo.jpg" alt="巡山客" class="logo-icon" />
        <p class="logo-subtitle">来巡山后台管理系统</p>
      </div>
      <el-form ref="loginForm" :model="loginForm" class="login-form">
        <el-form-item class="form-item">
          <label class="form-label">手机号</label>
          <el-input
            v-model="loginForm.mobile"
            placeholder="请输入手机号"
            prefix-icon="el-icon-phone"
            class="form-input"
          ></el-input>
        </el-form-item>
        <el-form-item class="form-item">
          <label class="form-label">密码</label>
          <el-input
            type="password"
            v-model="loginForm.password"
            placeholder="请输入密码"
            prefix-icon="el-icon-lock"
            class="form-input"
          ></el-input>
        </el-form-item>
        <el-form-item class="form-item">
          <el-button
            type="primary"
            class="login-btn"
            @click="handleLogin"
            :loading="loading"
          >
            进入系统
            <i class="el-icon-arrow-right"></i>
          </el-button>
        </el-form-item>
      </el-form>
      <div class="copyright">© 2026 上海巡山客户外运动有限公司 版权所有</div>
      <div class="icp-info">
        <a
          href="https://beian.miit.gov.cn/"
          target="_blank"
          rel="noopener noreferrer"
        >
          沪ICP备2026021332号
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      loginForm: {
        mobile: '',
        password: ''
      },
      loading: false
    }
  },
  methods: {
    async handleLogin() {
      if (!this.loginForm.mobile) {
        this.$message.error('请输入手机号')
        return
      }
      if (!this.loginForm.password) {
        this.$message.error('请输入密码')
        return
      }
      this.loading = true
      try {
        const res = await this.$http.post('admin/adminLogin.do', {
          mobile: this.loginForm.mobile,
          password: this.loginForm.password
        })

        // 保存token
        const tokenValue = res.object?.tokenValue || ''
        if (!tokenValue) {
          this.$message.error('登录失败：未获取到token')
          return
        }
        localStorage.setItem('token', tokenValue)

        // 保存用户信息
        const userInfo = res.result || {}
        localStorage.setItem(
          'userInfo',
          JSON.stringify({
            id: userInfo.id || '',
            name: userInfo.name || '',
            nickname: userInfo.nickname || '',
            mobile: userInfo.mobile || '',
            type: userInfo.type || 0,
            idCard: userInfo.idCard || '',
            provinceCode: userInfo.provinceCode || '',
            cityCode: userInfo.cityCode || '',
            addressDetail: userInfo.addressDetail || '',
            status: userInfo.status || 0
          })
        )

        this.$message.success('登录成功')
        this.$router.push('/routes')
      } catch (error) {
        this.$message.error(error.message || '登录失败，请检查手机号和密码')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.login-container {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(180deg, #f0fdf4 0%, #dcfce7 100%);
}

.login-box {
  width: 420px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
  padding: 48px 40px;
}

.logo-section {
  text-align: center;
  margin-bottom: 40px;
}

.logo-icon {
  width: 72px;
  height: 72px;
  border-radius: 16px;
  margin: 0 auto 16px;
  object-fit: cover;
}

.logo-title {
  font-size: 28px;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 8px 0;
}

.logo-subtitle {
  font-size: 14px;
  color: #9ca3af;
  margin: 0;
}

.login-form {
  margin-bottom: 32px;
}

.form-item {
  margin-bottom: 24px;
}

.form-label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  margin-bottom: 8px;
  text-align: left;
}

.form-input {
  width: 100%;
  height: 44px;
  border-radius: 8px;
  /* border: 1px solid #e5e7eb; */
  padding: 0;
  font-size: 14px;
}

.form-input .el-input__inner {
  border: none !important;
  border-radius: 8px !important;
  box-shadow: none !important;
  outline: none !important;
}

.form-input:focus {
  border-color: #22c55e !important;
  box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.1) !important;
}

.form-input:hover {
  border-color: #d1d5db !important;
}

.form-input .el-input__inner:focus {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}

.form-input.is-focus,
.form-input.is-focus .el-input__inner {
  border: none !important;
  box-shadow: none !important;
}

.login-btn {
  width: 100%;
  height: 48px;
  background: linear-gradient(135deg, #16a34a 0%, #15803d 100%);
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  color: #fff !important;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.login-btn span {
  color: #fff !important;
}

.login-btn i {
  color: #fff !important;
}

.login-btn:hover {
  background: linear-gradient(135deg, #15803d 0%, #166534 100%);
  color: #fff !important;
}

.login-btn:hover span,
.login-btn:hover i {
  color: #fff !important;
}

.login-btn i {
  font-size: 16px;
}

.copyright {
  text-align: center;
  font-size: 12px;
  color: #9ca3af;
  padding-top: 24px;
  border-top: 1px solid #f3f4f6;
}

.icp-info {
  text-align: center;
  margin-top: 8px;
  font-size: 12px;
}

.icp-info a {
  color: #9ca3af;
  text-decoration: none;
  transition: color 0.3s;
}

.icp-info a:hover {
  color: #22c55e;
}
</style>
